import classname from 'classnames'
import * as React from 'react'

import { Input, InputHTMLProps, InputProps } from '../../main/components/input'

enum BubblesInputTheme {
  light,
  dark,
}

interface BubblesInputThemeReturn {
  label: React.HTMLProps<HTMLHeadingElement>
  input: InputProps
}

function getInputTheme(theme: BubblesInputTheme): BubblesInputThemeReturn {
  switch (theme) {
    case BubblesInputTheme.light:
      return {
        label: {
          className: 'text-gray-400',
        },
        input: {
          theme: 'none',
          rounding: 'none',
          inputClass: 'bg-[#4a505f] border border-[#585f72] focus:bg-[#535a6b] focus:border-[#707990]',
        },
      }
    case BubblesInputTheme.dark:
      return {
        label: {
          className: 'text-gray-500',
        },
        input: {},
      }
  }
}

interface BubblesInputProps extends Omit<InputProps, 'theme'>, Omit<InputHTMLProps, 'ref'> {
  theme?: keyof typeof BubblesInputTheme
}

export function BubblesInput({ theme = 'light', label, ...props }: BubblesInputProps) {
  const inputTheme = React.useMemo(() => getInputTheme(BubblesInputTheme[theme]), [theme])

  return (
    <Input
      label={<h3 className={classname(inputTheme?.label.className, 'm-0 text-3xs uppercase')}>{label}</h3>}
      {...inputTheme.input}
      {...props}
    />
  )
}
